import { BusinessProfilePostData } from "../../../api/profileService/profileService";
import i18n from "../../../i18n";

type ErrorType = {
    error: boolean;
    message: string;
};

export type BusinessProfileErrorObj = {
    name: ErrorType;	
	vatnr: ErrorType;
}

export const validateBusinessProfileData = (data: BusinessProfilePostData) => {
    const errorObj: BusinessProfileErrorObj = {                
        name: {
            error: false,
            message: ""
        },
        vatnr: {
            error: false,
            message: ""
        }
    };            

    if(!data.name) {
        errorObj.name.error = true;
        errorObj.name.message = i18n.t('errors.requiredBusinessName');
    }

    if(!data.vatnr && data.vatnr !== null) {
        errorObj.vatnr.error = true;
        errorObj.vatnr.message = i18n.t('errors.requiredVat');
    }    

    return errorObj;
}